import React, { useContext, useEffect, useState } from "react";
import { LensDataProps, ProductTypeProps } from "./interface";
import { handlePriceChange } from "./hooks/useHelper";
import { useApiCalling } from "./hooks/useApiCall";
import organisms from "../../../../components/organisms";
import molecules from "../../../../components/molecules";
import { HeaderHeading } from "../../../../Context";
import Wrapper from "../../../../components/common/Wrapper/Wrapper";

const { LensVariety } = organisms;
const { ConfirmationModal } = molecules;

const Index = () => {
    const { setHeader }: any = useContext(HeaderHeading);
    const [productType, setProductType] = useState<ProductTypeProps[]>([]);
    const [productTypeId, setProductTypeId] = useState<string>("");
    const [lensTableData, setLensTableData] = useState<LensDataProps[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false);

    const { handleSubmit, getLensVarietyData, getProductTypeData } =
        useApiCalling();

    useEffect(() => {
        setHeader("E-commerce- Lens Variety");
        getProductTypeData(setProductType);
    }, []);

    return (
        <Wrapper>
            <LensVariety
                productType={productType}
                getLensVarietyData={(id: string) => {
                    getLensVarietyData({
                        id: id,
                        setLensTableData: (data: LensDataProps[]) => setLensTableData(data),
                    });
                    setProductTypeId(id)
                }
                }
                lensTableData={lensTableData}
                handleSubmit={() => setShowPopup(!showPopup)}
                handlePriceChange={(e, lensId, varietyId, addonId) =>
                    handlePriceChange({
                        e: e,
                        lensId: lensId,
                        varietyId: varietyId,
                        addonId: addonId,
                        lensTableData: lensTableData,
                        setLensTableData: setLensTableData,
                    })
                }
            />
            {showPopup && (
                <ConfirmationModal
                    show={showPopup}
                    handleConfirmItem={() =>
                        handleSubmit({
                            setShowPopup: setShowPopup,
                            showPopup: showPopup,
                            lensTableData: lensTableData,
                            productTypeId: productTypeId,
                        })
                    }
                    onHide={() => setShowPopup(!showPopup)}
                    message={"save the changes"}
                />
            )}
        </Wrapper>
    );
};

export default Index;
